import { render, staticRenderFns } from "./OutsideEnglandWales.vue?vue&type=template&id=60a7290a"
import script from "./OutsideEnglandWales.vue?vue&type=script&lang=js"
export * from "./OutsideEnglandWales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports